import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography ,IconButton} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { YES_NO } from '../../../../../constants';

export const InfertilityDetailsForm = ({ onAdd, onClose, setInfertilityDialog}) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
       
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmit = (formValue) => {
    onAdd(formValue);
    setInfertilityDialog(false);
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
         <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" sx={{ marginBottom:2,borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{marginBottom:"2%"}}>
          Infertility Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
    <Grid container spacing={2}>
  <Grid item xs={12}>
    <Stack spacing={2}>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.4rem' }}>Primary Infertility</Typography>
        <TextField sx={{ flex: 0.8 }} name="primary_infertility" placeholder="Primary Infertility" type="number" />
        <Typography sx={{ fontWeight: 600, fontSize: '1.4rem' }}>Yrs.</Typography>
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.45, fontWeight: 600, fontSize: '1.4rem' }}>Secondary Infertility</Typography>
        <TextField sx={{ flex: 0.4 }} name="secondary_infertility" placeholder="Secondary Infertility" type="number"/>
        <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Abortion</Typography>
        <TextField sx={{ flex: 0.4 }} name="abortion" placeholder="Abortion" type="number" />
        <Typography sx={{  fontWeight: 600, fontSize: '1.4rem' }}>months</Typography>
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>DNC Done</Typography>
        <TextField sx={{ flex: 1 }} name="dnc" placeholder="DNC"  />
      </Stack>

      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>If DNC Done then</Typography>

      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Doctor Name</Typography>
        <TextField sx={{ flex: 1 }} name="doctor"  />
      </Stack>

      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.45, fontWeight: 600, fontSize: '1.4rem' }}>MTP</Typography>
        <TextField sx={{ flex: 0.5 }} name="mtp"  />
        <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>By Doctor</Typography>
        <TextField sx={{ flex: 0.4 }} name="mtp_by_doctor"  />
      </Stack>

      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>IUD</Typography>
        <TextField sx={{ flex: 1 }} name="iud"  />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>NND</Typography>
        <TextField sx={{ flex: 1 }} name="nnd"  />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Other</Typography>
        <TextField sx={{ flex: 1 }} name="other"  multiline />
      </Stack>
    </Stack>
  </Grid>

</Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
